<template>
  <div class="map">
    <div id="allmap" ref="allmap" class="allmap"></div>
    <div class="left">
      <div class="leftItem" @click.stop="changeType('py')">平移</div>
      <div class="leftItem" @click.stop="changeType('big')">放大</div>
      <div class="leftItem" @click.stop="changeType('small')">缩小</div>
      <div class="leftItem" @click.stop="changeType('cl')">测量</div>
      <div class="leftItem" @click.stop="changeType('search')">管网搜索</div>
      <div class="leftItem" @click.stop="changeType('gw')">管网快捷查询</div>
      <div class="leftItem" @click.stop="changeType('ydym')">易堵易冒查询</div>
      <div class="leftItem" @click.stop="changeType('sb')">管网识别查询</div>
    </div>
    <div class="right" v-if="showRight">
      <div v-if="leftType === 'cl'">
        <map-distance
          :clResult="clResult"
          @beginDistance="beginDistance"
          @beginArea="beginArea"
        ></map-distance>
      </div>
      <div v-else-if="leftType === 'gw'">
        <map-gw @getGw="getGw"></map-gw>
      </div>
      <div v-else-if="leftType === 'ydym'">
        <map-ydym @getGw="getGw2"></map-ydym>
      </div>
      <div style="height: 100%" v-else-if="leftType === 'search'">
        <map-search @getGw="getGw"></map-search>
      </div>
    </div>
  </div>
</template>

<script>
import CommonApi from "@/api/common";
import MapDistance from "./component/distance";
import MapGw from "./component/gw";
import MapYdym from "./component/ydym";
import MapSearch from "./component/search";
import MapApi from "@/api/map";
export default {
  components: {
    MapDistance,
    MapGw,
    MapSearch,
    MapYdym,
  },
  data() {
    return {
      showRight: false,
      map: null,
      distanceTool: null,
      clResult: [],
      regionData: {},
      fs: [],
      showOverlay: true,
      infoBoxList: [],
      infoBoxList2: [],
      leftType: "cl",
      lineList: [],
      pointList: [],
      mapData: {},
      overlayList: [],
      selectAreaCode: "",

      searchResult: [],
      startPoint: null,
      rectangle: null,
      isDrawing: false,
      isMouseDown: false,
      isSBPointList: [],
    };
  },
  computed: {
    ceneterPoint() {
      const coordinates = this.$route.query.coordinates || "";
      return this.selectCode ? coordinates.split(",") : [];
    },
    selectCode() {
      return this.$route.query.towncode || "";
    },
  },

  mounted() {
    this.addMap();
    this.addControl();
    this.map.addEventListener("zoomend", (evt) => {
      if (
        this.map.getZoom() > 17 &&
        this.pointList &&
        this.pointList.length > 0
      ) {
        this.pointList.forEach((item) => {
          this.addPoint(item, this.mapData);
        });
      }
      if (this.map.getZoom() > 13 && this.showOverlay === true) {
        this.showOverlay = false;
        this.hideOverlays();
      } else if (this.map.getZoom() <= 13 && this.showOverlay === false) {
        this.showOverlay = true;
        this.showOverlays();
      }
    });
    this.distanceTool = new BMapGLLib.DistanceTool(this.map);
    // 监听测距过程中的鼠标事件
    this.distanceTool.addEventListener("drawend", (e) => {
      this.clResult.push(`${e.distance}米`);
    });
    CommonApi.streetGeomInfo({}).then((res) => {
      this.regionData = res.data.data;
      this.addPolygon();
    });
    window.showImage = (url) => {
      this.showImage(url);
    };
  },
  methods: {
    showImage(url) {
      let newWindow = window.open("_blank");
      newWindow.location.href = url;
    },
    addMap() {
      this.map = new BMapGL.Map("allmap");
      const pointDefault = [120.56019, 31.389191];
      const point = this.ceneterPoint;
      const [lng, lat] = this.selectCode ? point : pointDefault;
      const zoom = this.selectCode ? 14 : 10;
      const centerPoint = new BMapGL.Point(lng, lat);
      this.map.centerAndZoom(centerPoint, zoom);
      // if (this.selectCode) {
      //   this.map.centerAndZoom(
      //     new BMapGL.Point(this.ceneterPoint[0], this.ceneterPoint[1]),
      //     14
      //   )
      // } else {
      //   this.map.centerAndZoom(new BMapGL.Point(120.56019, 31.389191), 10)
      // }
    },
    addControl() {
      var opts1 = {
        anchor: BMAP_ANCHOR_TOP_RIGHT,
        offset: new BMapGL.Size(330, 30),
      };
      var opts2 = {
        anchor: BMAP_ANCHOR_BOTTOM_LEFT,
        // offset: new BMapGL.Size(330, 30),
      };
      this.map.enableScrollWheelZoom(true); //开启鼠标滚轮缩放
      var scaleCtrl = new BMapGL.ScaleControl(opts2); // 添加比例尺控件
      this.map.addControl(scaleCtrl);
    },
    changeType(value) {
      if (this.leftType != value) {
        this.hideOtherOverlays();
      }
      this.leftType = value;
      if (value === "big") {
        this.showRight = false;
        this.map.centerAndZoom(
          new BMapGL.Point(this.map.getCenter().lng, this.map.getCenter().lat),
          this.map.zoomLevel + 1
        );
        this.isMouseDown = false;
        this.map.enableDragging();
      } else if (value === "small") {
        this.showRight = false;
        this.map.centerAndZoom(
          new BMapGL.Point(this.map.getCenter().lng, this.map.getCenter().lat),
          this.map.zoomLevel - 1
        );
        this.isMouseDown = false;

        this.map.enableDragging();
      } else if (value === "py") {
        this.showRight = false;
        this.map.centerAndZoom(
          new BMapGL.Point(
            this.map.getCenter().lng + 0.01,
            this.map.getCenter().lat
          ),
          this.map.zoomLevel
        );
        this.isMouseDown = false;

        this.map.enableDragging();
      } else if (value === "ydym") {
        this.showRight = true;
        this.getGw2({
          townCode: "",
          roadId: "",
        });
        this.isMouseDown = false;

        this.map.enableDragging();
      } else if (value === "sb") {
        const vm = this;
        this.map.centerAndZoom(
          new BMapGL.Point(
            this.map.getCenter().lng + 0.01,
            this.map.getCenter().lat
          ),
          this.map.zoomLevel
        );
        this.isMouseDown = true;
        this.map.enableScrollWheelZoom(); // 启用地图滚轮缩放
        this.map.addEventListener("mousedown", this.mouseDownHandler);
      } else {
        this.showRight = true;
        this.searchResult = [];
        this.isMouseDown = false;

        this.map.enableDragging();
      }
    },

    async pipeInfoByMultipolygon() {
      this.getGw3();
    },

    mouseDownHandler(e) {
      if (!this.isMouseDown) {
        return;
      }
      this.startPoint = e.latlng;
      document.addEventListener("mousemove", this.mouseMoveHandler);
      document.addEventListener("mouseup", this.mouseUpHandler);
      this.isDrawing = true;
      this.map.disableDragging();
    },

    mouseMoveHandler(e) {
      if (!this.isMouseDown) {
        return;
      }

      if (!this.startPoint) {
        return;
      }
      var endPoint = this.map.pixelToPoint(
        new BMapGL.Pixel(e.clientX - 200, e.clientY - 100)
      );
      if (this.rectangle) {
        this.map.removeOverlay(this.rectangle);
      }
      var path = [
        new BMapGL.Point(this.startPoint.lng, this.startPoint.lat),
        new BMapGL.Point(endPoint.lng, this.startPoint.lat),
        new BMapGL.Point(endPoint.lng, endPoint.lat),
        new BMapGL.Point(this.startPoint.lng, endPoint.lat),
      ];
      this.rectangle = new BMapGL.Polygon(path, {
        strokeColor: "blue",
        strokeWeight: 2,
        fillColor: "transparent",
        fillOpacity: 0,
      });
      this.map.addOverlay(this.rectangle);
    },
    mouseUpHandler(e) {
      if (!this.isMouseDown) {
        return;
      }
      document.removeEventListener("mousemove", this.mouseMoveHandler);
      document.removeEventListener("mouseup", this.mouseUpHandler);
      if (this.isDrawing) {
        this.map.enableDragging();
        this.isDrawing = false;
      }
      if (this.rectangle) {
        var bounds = this.rectangle.getBounds();
        if (bounds) {
          const vm = this;
          var southWest = bounds.getSouthWest();
          var northEast = bounds.getNorthEast();
          var southEast = new BMapGL.Point(northEast.lng, southWest.lat);
          var northWest = new BMapGL.Point(southWest.lng, northEast.lat);

          vm.isSBPointList = [];
          // var points = [
          //   new BMapGL.Point(northWest.lng, northWest.lat),
          //   new BMapGL.Point(southWest.lng, southWest.lat),
          //   new BMapGL.Point(southEast.lng, southEast.lat),
          //   new BMapGL.Point(northEast.lng, northEast.lat),
          // ];

          var points = [
            { lng: northWest.lng, lat: northWest.lat },
            { lng: southWest.lng, lat: southWest.lat },
            { lng: southEast.lng, lat: southEast.lat },
            { lng: northEast.lng, lat: northEast.lat },
          ];

          this.isSBPointList.push(...points);

          // var convertor = new BMapGL.Convertor();
          // convertor.translate(
          //   points,
          //   COORDINATES_BD09,
          //   COORDINATES_WGS84,
          //   (data) => {
          //     if (data.status === 0) {
          //       vm.isSBPointList = data.points;
          //     }
          //   }
          // );

          setTimeout(() => {
            vm.pipeInfoByMultipolygon();
          }, 1000);

          // console.log('西北角坐标：' + northWest.lng + ', ' + northWest.lat)
          // console.log('西南角坐标：' + southWest.lng + ', ' + southWest.lat)
          // console.log('东南角坐标：' + southEast.lng + ', ' + southEast.lat)
          // console.log('东北角坐标：' + northEast.lng + ', ' + northEast.lat)

          // this.map.setViewport([bounds.getSouthWest(), bounds.getNorthEast()]);
          this.map.removeOverlay(this.rectangle);
        } else {
          // console.log('无法获取矩形角坐标。')
        }
      } else {
        // console.log('无法获取矩形角坐标。')
      }
    },

    beginDistance() {
      this.clResult = [];
      this.hideOtherOverlays();
      this.distanceTool.open();
    },
    beginArea() {
      this.clResult = [];
      this.hideOtherOverlays();
      let styleOptions = {
        strokeColor: "#5E87DB", // 边线颜色
        fillColor: "#5E87DB", // 填充颜色。当参数为空时，圆形没有填充颜色
        strokeWeight: 2, // 边线宽度，以像素为单位
        strokeOpacity: 1, // 边线透明度，取值范围0-1
        fillOpacity: 0.2, // 填充透明度，取值范围0-1
      };
      let labelOptions = {
        borderRadius: "2px",
        background: "#FFFBCC",
        border: "1px solid #E1E1E1",
        color: "#703A04",
        fontSize: "12px",
        letterSpacing: "0",
        padding: "5px",
      };
      // 实例化鼠标绘制工具
      let drawingManager = new BMapGLLib.DrawingManager(this.map, {
        enableCalculate: true, // 绘制是否进行测距测面
        enableSorption: true, // 是否开启边界吸附功能
        sorptiondistance: 20, // 边界吸附距离
        enableGpc: true, // 是否开启延边裁剪功能
        enableLimit: true, // 是否开启超限提示
        limitOptions: {
          area: 50000000, // 面积超限值
          distance: 30000, // 距离超限值
        },
        circleOptions: styleOptions, // 圆的样式
        polylineOptions: styleOptions, // 线的样式
        polygonOptions: styleOptions, // 多边形的样式
        rectangleOptions: styleOptions, // 矩形的样式
        labelOptions: labelOptions, // label样式
      });
      // 进行绘制
      if (
        drawingManager._isOpen &&
        drawingManager.getDrawingMode() === BMAP_DRAWING_POLYGON
      ) {
        drawingManager.close();
      } else {
        drawingManager.setDrawingMode(BMAP_DRAWING_POLYGON);
        drawingManager.open();
      }
      drawingManager.addEventListener("overlaycomplete", (e) => {
        if (e.calculate === null) {
          this.clResult.push(`面积不能超过50平方公里`);
        } else {
          let area = (e.calculate / 1000000).toFixed(4);
          this.clResult.push(`${area}平方公里`);
        }
      });
    },

    hideOtherOverlays() {
      var markers = this.map.getOverlays();
      markers.forEach((item) => {
        if (
          item.name != "car" &&
          item.name != "areaName" &&
          item.name != "area"
        ) {
          this.map.removeOverlay(item);
        }
      });
    },
    hideOverlays() {
      var markers = this.map.getOverlays();
      markers.forEach((item) => {
        if (item.name === "area" || item.name === "areaName") {
          this.map.removeOverlay(item);
        }
      });
      this.addPolygon(true);
    },
    showOverlays() {
      var markers = this.map.getOverlays();
      markers.forEach((item) => {
        if (item.toString() === "Polygon" || item.toString() === "Label") {
          this.map.removeOverlay(item);
        }
      });
      this.addPolygon();
    },
    getGw(value) {
      this.lineList = [];
      this.pointList = [];
      this.infoBoxList2 = [];
      if (value) {
        MapApi.pipeGeomInfo2({
          townCode: value.townCode,
          roadId: value.roadId,
        }).then((res) => {
          if (res.data.code === 200) {
            this.hideOtherOverlays();
            this.lineList = res.data.data.lineInfoVo;
            this.pointList = res.data.data.wellInfoVo;
            this.mapData = res.data.data.map;
            let centerPt = new BMapGL.Point(
              res.data.data.longitude,
              res.data.data.latitude
            );
            setTimeout(function () {
              var convertor = new BMapGL.Convertor();
              var pointArr = [];
              pointArr.push(centerPt);
              convertor.translate(
                pointArr,
                COORDINATES_WGS84,
                COORDINATES_BD09,
                translateCallback
              );
            }, 1000);
            //坐标转换完之后的回调函数
            let translateCallback = (data) => {
              if (data.status === 0) {
                this.map.centerAndZoom(data.points[0], 15);
              }
            };
            // this.pointList.forEach(item => {
            //   this.addPoint(item, res.data.data)
            // })
            this.lineList.forEach((line) => {
              let json = JSON.parse(line.lineGeoJson);
              if (json.type === "MultiLineString") {
                this.addLine(json.coordinates[0], line, res.data.data);
              } else {
                this.addLine(json.coordinates, line, res.data.data);
              }
            });
          }
        });
      }
    },
    getGw2(value) {
      this.lineList = [];
      this.pointList = [];
      this.infoBoxList2 = [];
      if (value) {
        MapApi.pipeGeomInfo2({
          blockBurstTag: 1,
          townCode: value.townCode,
          roadId: value.roadId,
        }).then((res) => {
          if (res.data.code === 200) {
            this.hideOtherOverlays();
            this.lineList = res.data.data.lineInfoVo;
            this.pointList = res.data.data.wellInfoVo;
            this.mapData = res.data.data.map;
            // this.pointList.forEach(item => {
            //   this.addPoint(item, res.data.data)
            // })
            this.lineList.forEach((line) => {
              let json = JSON.parse(line.lineGeoJson);
              if (json.type === "MultiLineString") {
                this.addLine(json.coordinates[0], line, res.data.data);
              } else {
                this.addLine(json.coordinates, line, res.data.data);
              }
            });
          }
        });
      }
    },
    getGw3() {
      this.lineList = [];
      this.pointList = [];
      this.infoBoxList2 = [];
      const loading = this.$loading({
        lock: true,
        text: "加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      if (this.isSBPointList && this.isSBPointList.length > 0) {
        MapApi.pipeInfoByMultipolygon({
          pointList: this.isSBPointList,
        })
          .then((res) => {
            if (res.data.code === 200) {
              this.hideOtherOverlays();
              this.lineList = res.data.data.lineInfoVo;
              this.pointList = res.data.data.wellInfoVo;
              this.mapData = res.data.data.map;
              if (!this.pointList || this.pointList.length === 0) {
                loading.close();
                this.$message.error("未查询到数据");

                return;
              }
              let centerPt = new BMapGL.Point(
                res.data.data.longitude,
                res.data.data.latitude
              );
              setTimeout(function () {
                var convertor = new BMapGL.Convertor();
                var pointArr = [];
                pointArr.push(centerPt);
                convertor.translate(
                  pointArr,
                  COORDINATES_WGS84,
                  COORDINATES_BD09,
                  translateCallback
                );
              }, 1000);
              //坐标转换完之后的回调函数
              let translateCallback = (data) => {
                if (data.status === 0) {
                  this.map.centerAndZoom(data.points[0], 15);
                }
              };
              // this.pointList.forEach(item => {
              //   this.addPoint(item, res.data.data)
              // })
              this.lineList.forEach((line) => {
                let json = JSON.parse(line.lineGeoJson);
                if (json.type === "MultiLineString") {
                  this.addLine(json.coordinates[0], line, res.data.data);
                } else {
                  this.addLine(json.coordinates, line, res.data.data);
                }
              });

              setTimeout(() => {
                loading.close();
              }, 1000);
            } else {
              this.$message.error("未查询到数据");
              loading.close();
            }
          })
          .catch((err) => {
            this.$message.error("未查询到数据");
            loading.close();
          });
      }
    },
    goToSearch(value) {
      var that = this;
      var options = {
        onSearchComplete: function (results) {
          // 判断状态是否正确
          if (local.getStatus() == BMAP_STATUS_SUCCESS) {
            let s = [];
            for (var i = 0; i < results.getCurrentNumPois(); i++) {
              s.push([results.getPoi(i).title, results.getPoi(i).address]);
              //画点
              var pt = new BMapGL.Point(
                results.getPoi(i).point.lng,
                results.getPoi(i).point.lat
              );
              // 创建小车图标

              let dic = {};
              var marker = new BMapGL.Marker(pt, dic);
              marker.name = "searchResult";
              // 将标注添加到地图
              that.map.addOverlay(marker);
            }
            that.searchResult = s;
          }
        },
      };
      var local = new BMapGL.LocalSearch(this.map, options);
      local.setPageCapacity(20);
      local.search("江苏省苏州市吴江区" + value);
    },
    addPoint(item, data1) {
      let that = this;
      //画点
      var pt = new BMapGL.Point(item.longitude, item.latitude);
      // 创建小车图标
      let image = require("@/assets/teamGroup/jg_icon.png");
      var myIcon = new BMapGL.Icon(image, new BMapGL.Size(20, 20));

      let dic = {
        icon: myIcon,
      };
      setTimeout(function () {
        var convertor = new BMapGL.Convertor();
        var pointArr = [];
        pointArr.push(pt);
        convertor.translate(
          pointArr,
          COORDINATES_WGS84,
          COORDINATES_BD09,
          translateCallback
        );
      }, 1000);
      //坐标转换完之后的回调函数
      let translateCallback = (data) => {
        if (data.status === 0) {
          var marker = new BMapGL.Marker(data.points[0], dic);
          marker.name = "gj";
          this.map.addOverlay(marker);

          let html = [
            "<div class='infoContent'>",
            `<div class='title'><strong style='color: white;font-size: 16px'>${
              item.source == 1 ? "雨水" : "污水"
            }管井</strong></div>`,
            "<div class='infoList'>",
            `<div class='infoItem'><div class='infoTitle'>管网编号：</div><div class='infoNumber'>${
              item.gdid == null ? "无" : item.gdid
            }</div></div>`,
            `<div class='infoItem'><div class='infoTitle'>所属区域：</div><div class='infoNumber'>${
              item.townName == null ? "无" : item.townName
            }</div></div>`,
            `<div class='infoItem'><div class='infoTitle'>道路名称：</div><div class='infoNumber'>${
              item.roadName == null ? "无" : item.roadName
            }</div></div>`,
            `<div class='infoItem'><div class='infoTitle'>横坐标：</div><div class='infoNumber'>${
              item.xcoordinate == null ? "无" : item.xcoordinate
            }</div></div>`,
            `<div class='infoItem'><div class='infoTitle'>纵坐标：</div><div class='infoNumber'>${
              item.ycoordinate == null ? "无" : item.ycoordinate
            }</div></div>`,
            `<div class='infoItem'><div class='infoTitle'>井底埋深：</div><div class='infoNumber'>${
              item.burialDepth == null ? "无" : item.burialDepth
            }</div></div>`,
            `<div class='infoItem'><div class='infoTitle'>井盖材质：</div><div class='infoNumber'>${
              item.manholeCoverMaterial == null
                ? "无"
                : item.manholeCoverMaterial
            }</div></div>`,
            `<div class='infoItem'><div class='infoTitle'>井盖形状：</div><div class='infoNumber'>${
              item.shape == null ? "无" : item.shape
            }</div></div>`,
            `<div class='infoItem'><div class='infoTitle'>井盖直径：</div><div class='infoNumber'>${
              item.wellZj == null ? "无" : Number(item.wellZj)
            }</div></div>`,
            `<div class='infoItem'><div class='infoTitle'>井盖尺寸：</div><div class='infoNumber'>${
              item.wellFrameSize == null ? "无" : item.wellFrameSize
            }</div></div>`,
            `<div class='infoItem'><div class='infoTitle'>修建年代：</div><div class='infoNumber'>${
              item.inwellEra == null ? "无" : item.inwellEra
            }</div></div>`,
            `<div class='infoItem'><div class='infoTitle'>探查日期：</div><div class='infoNumber'>${item.tcrq}</div></div>`,
            `<div class='infoItem'><div class='infoTitle'>养护状态：</div><div class='infoNumber'>${
              item.yhzt == null ? "无" : item.yhzt
            }</div></div>`,
          ];
          let imgCount = 0;
          let dataDmt = {};
          if (data1.map[item.roadId]) {
            dataDmt = data1.map[item.roadId];
          }
          if (dataDmt.photoUrl != null) {
            let array = dataDmt.photoUrl.split(",");
            let string = `<div class='infoItem'><div class='infoTitle'>养护图片：</div><div class='infoImage'>`;
            array.forEach((imgItem) => {
              if (imgItem && imgItem.length > 0) {
                imgCount++;
                string += `<img class='imgItem' onclick="showImage('${imgItem}')" src="${imgItem}" alt=""/>`;
              }
            });
            string += `</div></div>`;
            html.push(string);
          }
          let imgCount2 = 0;
          if (dataDmt.cameraUrl != null) {
            let array = dataDmt.cameraUrl.split(",");
            let string = `<div class='infoItem'><div class='infoTitle'>养护视频：</div><div class='infoImage'>`;
            array.forEach((imgItem) => {
              if (imgItem && imgItem.length > 0) {
                imgCount2++;
                string += `<video class='imgItem2' onclick="showImage('${imgItem}')" src="${imgItem}" controls="controls" alt=""></video>`;
              }
            });
            string += `</div></div>`;
            html.push(string);
          }
          html.push("</div>");
          html.push("</div>");
          let infoBox = new BMapGLLib.InfoBox(this.map, html.join(""), {
            boxStyle: {
              width: "270px",
              height:
                440 + (Math.ceil(imgCount / 3) * 50 + imgCount2 * 100) + "px",
              "border-radius": "10px",
              "background-color": "rgba(64, 158, 255, 0.8)",
              border: "1px solid rgba(64, 158, 255, 1)",
              padding: "10px",
            },
            closeIconMargin: "0 4px 0 0",
            closeIconUrl: require("@/assets/teamGroup/map_close.png"),
            closeIconWidth: "20px",
            enableAutoPan: true,
            align: INFOBOX_AT_BOTTOM,
            offset: new BMapGL.Size(
              140,
              -320 - (Math.ceil(imgCount / 3) * 50 + imgCount2 * 100)
            ),
          });
          // marker添加点击事件
          marker.addEventListener("mouseover", function (e) {
            that.infoBoxList2.forEach((item) => {
              item.close();
            });
            infoBox.open(marker);
          });
          this.infoBoxList2.push(infoBox);
        }
      };
    },
    addLine(el, item, data1) {
      let tempList = [];
      el.forEach((subEl) => {
        let linep = new BMapGL.Point(subEl[0], subEl[1]);
        tempList.push(linep);
      });
      setTimeout(function () {
        var convertor = new BMapGL.Convertor();
        convertor.translate(
          tempList,
          COORDINATES_WGS84,
          COORDINATES_BD09,
          translateCallback
        );
      }, 1000);

      let translateCallback = (data) => {
        if (data.status === 0) {
          let polyline = new BMapGL.Polyline(data.points, {
            strokeColor: item.source === "2" ? "orange" : "green",
            strokeWeight: 8,
            strokeStyle: "solid",
          });

          let lat = 0;
          let long = 0;
          data.points.forEach((subEl) => {
            lat += subEl.lat;
            long += subEl.lng;
          });
          this.map.addOverlay(polyline);

          let html = [
            "<div class='infoContent'>",
            `<div class='title'><strong style='color: white;font-size: 16px'>${
              item.source == 1 ? "雨水" : "污水"
            }管道</strong></div>`,
            "<div class='infoList'>",
            `<div class='infoItem'><div class='infoTitle'>管网编号：</div><div class='infoNumber'>${
              item.gdid == null ? "无" : item.gdid
            }</div></div>`,
            `<div class='infoItem'><div class='infoTitle'>所属区域：</div><div class='infoNumber'>${
              item.regionName == null ? "无" : item.regionName
            }</div></div>`,
            `<div class='infoItem'><div class='infoTitle'>道路名称：</div><div class='infoNumber'>${
              item.roadName == null ? "无" : item.roadName
            }</div></div>`,
            `<div class='infoItem'><div class='infoTitle'>本点号：</div><div class='infoNumber'>${
              item.thisPointNumber == null ? "无" : item.thisPointNumber
            }</div></div>`,
            `<div class='infoItem'><div class='infoTitle'>上点号：</div><div class='infoNumber'>${
              item.upPointNumber == null ? "无" : item.upPointNumber
            }</div></div>`,
            `<div class='infoItem'><div class='infoTitle'>本点埋深：</div><div class='infoNumber'>${
              item.thisPointBurialDepth == null
                ? "无"
                : item.thisPointBurialDepth
            }</div></div>`,
            `<div class='infoItem'><div class='infoTitle'>上点埋深：</div><div class='infoNumber'>${
              item.upPointBurialDepth == null ? "无" : item.upPointBurialDepth
            }</div></div>`,
            `<div class='infoItem'><div class='infoTitle'>埋设方式：</div><div class='infoNumber'>${
              item.msfs == null ? "无" : item.msfs
            }</div></div>`,
            `<div class='infoItem'><div class='infoTitle'>管道材质：</div><div class='infoNumber'>${
              item.tubing == null ? "无" : item.tubing
            }</div></div>`,
            `<div class='infoItem'><div class='infoTitle'>管道外径：</div><div class='infoNumber'>${
              item.gwj == null ? "无" : Number(item.gwj)
            }</div></div>`,
            `<div class='infoItem'><div class='infoTitle'>管道内径：</div><div class='infoNumber'>${
              item.gnj == null ? "无" : Number(item.gnj)
            }</div></div>`,
            `<div class='infoItem'><div class='infoTitle'>埋设年代：</div><div class='infoNumber'>${
              item.burialDate == null ? "无" : item.burialDate
            }</div></div>`,
            `<div class='infoItem'><div class='infoTitle'>探查日期：</div><div class='infoNumber'>${
              item.tcrq == null ? "无" : item.tcrq
            }</div></div>`,
            `<div class='infoItem'><div class='infoTitle'>养护状态：</div><div class='infoNumber'>${
              item.yhzt == null ? "无" : item.yhzt
            }</div></div>`,
          ];
          let imgCount = 0;
          let dataDmt = {};
          if (data1.map[item.roadId]) {
            dataDmt = data1.map[item.roadId];
          }
          if (dataDmt.photoUrl != null) {
            let array = dataDmt.photoUrl.split(",");
            let string = `<div class='infoItem'><div class='infoTitle'>养护图片：</div><div class='infoImage'>`;
            array.forEach((imgItem) => {
              if (imgItem && imgItem.length > 0) {
                imgCount++;
                string += `<img class='imgItem' onclick="showImage('${imgItem}')" src="${imgItem}" alt=""/>`;
              }
            });
            string += `</div></div>`;
            html.push(string);
          }

          let imgCount2 = 0;
          if (dataDmt.cameraUrl != null) {
            let array = dataDmt.cameraUrl.split(",");
            let string = `<div class='infoItem'><div class='infoTitle'>养护视频：</div><div class='infoImage'>`;
            array.forEach((imgItem) => {
              if (imgItem && imgItem.length > 0) {
                imgCount2++;
                string += `<video class='imgItem2' onclick="showImage('${imgItem}')" src="${imgItem}" controls="controls" alt=""></video>`;
              }
            });
            string += `</div></div>`;
            html.push(string);
          }
          html.push("</div>");
          html.push("</div>");
          let infoBox = new BMapGLLib.InfoBox(this.map, html.join(""), {
            boxStyle: {
              width: "270px",
              height:
                480 + (Math.ceil(imgCount / 3) * 50 + imgCount2 * 100) + "px",
              "border-radius": "10px",
              "background-color": "rgba(64, 158, 255, 0.8)",
              border: "1px solid rgba(64, 158, 255, 1)",
              padding: "10px",
            },
            closeIconMargin: "0 4px 0 0",
            closeIconUrl: require("@/assets/teamGroup/map_close.png"),
            closeIconWidth: "20px",
            enableAutoPan: true,
            align: INFOBOX_AT_BOTTOM,
            offset: new BMapGL.Size(
              200,
              -300 - (Math.ceil(imgCount / 3) * 50 + imgCount2 * 100)
            ),
          });
          let that = this;
          // marker添加点击事件
          polyline.addEventListener("mouseover", function (e) {
            that.infoBoxList2.forEach((item) => {
              item.close();
            });
            let point = new BMapGL.Point(long / 2, lat / 2);
            let marker = new BMapGL.Marker(point);
            marker.name = "gjLine";
            infoBox.open(marker);
          });
          this.infoBoxList2.push(infoBox);
        }
      };
    },
    addPolygon(flag = false) {
      const geoJson = this.regionData;
      this.overlayList = [];
      const region = {
        type: "FeatureCollection",
        features: [],
      };
      const features = geoJson.map((item) => {
        return {
          type: "Feature",
          properties: {
            type: "area",
            adcode: item.townCode,
            name: item.townName,
            center: JSON.parse(item.centroidGeoJson).coordinates,
            centroid: JSON.parse(item.centroidGeoJson).coordinates,
          },
          geometry: JSON.parse(item.streetGeoJson),
        };
      });
      region.features = features;
      // json.forEach(item => {
      //   const dic = {
      //     type: 'Feature',
      //     properties: {
      //       type: 'area',
      //       adcode: item.townCode,
      //       name: item.townName,
      //       center: JSON.parse(item.centroidGeoJson).coordinates,
      //       centroid: JSON.parse(item.centroidGeoJson).coordinates
      //     },
      //     geometry: JSON.parse(item.streetGeoJson)
      //   }
      //   region.features.push(dic)
      // })

      const that = this;
      const colorBand = ["#409EFF", "cadetblue", "orange", "red", "tan"];
      const gParse = new BMapGL.GeoJSONParse({
        reference: "WGS84",
      });
      this.fs = gParse.readFeaturesFromObject(
        region,
        {
          fillColor: "transparent",
          fillOpacity: flag === false && that.map.getZoom() <= 13 ? 0.2 : 0,
        },
        function (overlay) {
          var index = overlay.properties.join || 0;
          overlay.setFillColor(colorBand[index]);
          overlay.setStrokeColor(colorBand[index]);
          overlay.setZIndex(-2);
          overlay.addEventListener("mouseover", function (e) {
            e.currentTarget.setFillColor("red");
          });
          overlay.addEventListener("mouseout", function (e) {
            e.currentTarget.setFillColor(colorBand[index]);
          });
          overlay.addEventListener("click", function (e) {
            if (that.map.getZoom() < 14) {
              that.map.centerAndZoom(
                new BMapGL.Point(
                  overlay.properties.center[0],
                  overlay.properties.center[1]
                ),
                14
              );
            }
          });
          overlay.name = "area";
          that.map.addOverlay(overlay);

          var point = new BMapGL.Point(
            overlay.properties.center[0],
            overlay.properties.center[1]
          ); // 创建文字标注的位置点
          var label = new BMapGL.Label(overlay.properties.name, {
            offset: new BMapGL.Size(-10, -10),
          }); // 创建文字标注对象
          label.name = "areaName";
          label.setStyle({
            // 设置文字标注样式
            "background-color": colorBand[index],
            border: "1px solid white",
            color: "white", // 文字颜色
            "border-radius": "4px",
            padding: "0px 6px",
            fontSize: "14px", // 文字大小
            height: "20px", // 文字高度
            lineHeight: "20px", // 文字行高
            fontFamily: "微软雅黑", // 文字字体
          });
          label.setPosition(point); // 设置文字标注的位置
          that.map.addOverlay(label); // 将文字标注添加到地图中
          that.overlayList.push(overlay);
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
body,
html,
.allmap,
.map {
  width: 100%;
  height: 100%;
  overflow: hidden;
  margin: 0;
}
.map {
  position: relative;
  .left {
    position: absolute;
    top: 6px;
    left: 6px;
    width: 200px;
    height: calc(100% - 50px);
    border-radius: 10px;
    background-color: rgba(64, 158, 255, 0.8);
    z-index: 99;
    color: white;
    padding: 20px;
    .leftItem {
      height: 40px;
      line-height: 40px;
      font-size: 16px;
      cursor: pointer;
    }
  }
  .right {
    position: absolute;
    top: 6px;
    right: 6px;
    width: 300px;
    height: calc(100% - 20px);
    border-radius: 10px;
    background-color: rgba(64, 158, 255, 0.8);
    z-index: 99;
    color: white;
    padding: 20px;
  }
}
</style>
<style lang="scss">
.infoContent {
  width: 100%;
  height: 100%;
  .infoList {
    display: flex;
    flex-direction: column;
    margin-top: 10px;
    .infoItem {
      display: flex;
      flex-direction: row;
      color: white;
      min-height: 30px;
      height: auto;
      line-height: 30px;
      .infoTitle {
        text-align: right;
        width: 80px;
        flex-shrink: 0;
      }
      .infoNumber {
        text-align: left;
        flex: 1;
        width: calc(100% - 80px);
      }
      .infoImage {
        flex: 1;
        height: auto;
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        .imgItem {
          width: 40px;
          height: 40px;
          margin-right: 6px;
          margin-bottom: 6px;
        }
        .imgItem2 {
          width: 100%;
          height: 90px;
          margin-right: 6px;
          margin-bottom: 6px;
        }
      }
    }
  }
}
</style>
